import { type ProgramIncrementIterationAttributes } from './generated/ProgramIncrementIterationAttributes';
import ApplicationModel, { attr } from '../ApplicationModel';
import { model } from '../modelBuilder';

interface ProgramIncrementIteration
  extends ProgramIncrementIterationAttributes {}

@model
class ProgramIncrementIteration extends ApplicationModel {
  // Start auto-generated
  static typename: 'ProgramIncrementIteration' = 'ProgramIncrementIteration';
  get typename(): 'ProgramIncrementIteration' {
    return 'ProgramIncrementIteration';
  }

  static internalTypename: 'ProgramIncrementIteration' =
    'ProgramIncrementIteration';
  get internalTypename(): 'ProgramIncrementIteration' {
    return 'ProgramIncrementIteration';
  }

  static inputType = 'ProgramIncrementIterationAttributes!';

  static filterType = 'ProgramIncrementIterationFilters!';
  static filters = { programIncrementId: 'ID' };

  static fields = {
    createdAt: attr({ readable: true }),
    duration: attr({ writable: true, readable: true }),
    id: attr({ readable: true }),
    iterationsCount: attr({ readable: true }),
    name: attr({ writable: true, readable: true }),
    programIncrementId: attr({ readable: true }),
    startDate: attr({ writable: true, readable: true }),
    updatedAt: attr({ readable: true }),
    permissions: attr.belongsTo({
      readable: true,
      typename: 'ResourcePermissions',
    }),
    programIncrement: attr.belongsTo({
      readable: true,
      typename: 'ProgramIncrement',
    }),
    iterations: attr.hasMany({ readable: true }),
  };
  // End auto-generated
}

export default ProgramIncrementIteration;
